export const MENU_LOCATION = {
  LEFT: 'left',
  BOTTOM: 'bottom',
};
